<div
  @enterFadeIn
  class="group relative flex items-center justify-between gap-3 overflow-hidden rounded-lg border p-5 shadow-sm"
  [ngClass]="classes.container">
  <div class="absolute right-0 top-0 h-full w-1" [ngClass]="classes.bar"></div>
  <div class="z-10 flex min-w-0 flex-1 items-center gap-4">
    <div
      class="relative flex h-14 w-14 shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white p-3"
      [ngClass]="classes.icon">
      <mat-icon
        [fontIcon]="icon()"
        class="material-symbols-outlined h-fit w-fit text-3xl" />
      @if (alert()) {
        <span
          class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center">
          <span
            class="absolute inline-flex h-3 w-3 animate-ping rounded-full bg-red-300 opacity-75"></span>
          <span
            class="relative inline-flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white"
            >!</span
          >
        </span>
      }
    </div>
    <div class="min-w-0">
      <div class="text-3xl font-bold text-slate-800">{{ count() }}</div>
      <div
        class="truncate text-sm font-medium text-gray-500"
        [matTooltip]="label()">
        {{ label() }}
      </div>
    </div>
  </div>
  <button
    type="button"
    class="z-10 flex shrink-0 items-center whitespace-nowrap text-sm font-semibold"
    [ngClass]="classes.link"
    (click)="onAction()">
    {{ linkText() }}
    <mat-icon fontIcon="arrow_forward" class="ml-1 h-fit w-fit text-base" />
  </button>
</div>
